import get from './get';
import nodes from './nodes';

export default { get, nodes };
